<template lang="pug">
	.schedule-editor-instruction-line.schedule-cell.schedule-item.flex-row(:class="[ (itemIndex % 2) ? 'odd' : 'even', isRemoving ? 'removing vibrate-1' : '' ]")
		.schedule-cell.flex-col
			.schedule-content.flex-row.center.align-center.space.schedule-dates
				.flex-col.flex-1.full-height
					.flex-row.justify.actions(v-if="!readonly", @click="c => { isRemoving = true; $emit('remove', item, itemIndex) }")
						i.fas.fa-trash
				.flex-col.space
					.flex-col
						.font-small.upper.grey {{$tCaption('Start')}}
						DxDateBox(:value.sync="item.StartDateTime", :width="120", :disabled="readonly")
					.flex-col
						.font-small.upper.grey {{$tCaption('Finish')}}
						DxDateBox(:value.sync="item.EndDateTime", :width="120", :disabled="readonly")
		.flex-col
			.schedule-cell
				.swing-in-top-fwd.target-item.flex-col
					.flex-row
						.markets.flex-col.space.align-start.schedule-cell
							.cell-content
								.schedule-content
									.flex-col
										.font-small.upper.grey {{$tCaption('Target')}}
										.flex-col.space
											template(v-if="!item.isOtherTraffic")
												Dropdown(:getTotal="(data) => null", :getItems="(data) => data", :getData="loadMarketsData", :disabled="readonly"
													:columns="[{ dataField: 'name', caption: $tCaption('Market') }]",
													displayExpr="name",
													valueExpr="name",
													:placeholder="$tCaption('Markets')",
													v-model="markets",
													:showColumnHeaders="false",
													@select="keys => select('Zone', true, keys)",
													@deselect="keys => select('Zone', false, keys)")
												Dropdown(ref="formats", :getTotal="(data) => null", :getItems="(data) => data", :getData="loadFormatsData", :disabled="readonly"
													:columns="[{ dataField: 'name', caption: $tCaption('Format') }]",
													displayExpr="name",
													valueExpr="name",
													:placeholder="$tCaption('Formats')",
													v-model="formats",
													:showColumnHeaders="false",
													@select="keys => select('Format', true, keys)",
													@deselect="keys => select('Format', false, keys)")
												Dropdown(ref="stations", :getTotal="(data) => null", :getItems="(data) => data.items", :getData="loadStationsData", :disabled="readonly"
													:columns="[{ dataField: 'station', caption: $tCaption('Station') }, { dataField: 'slogan', caption: $tCaption('Slogan')}]",
													displayExpr="station",
													valueExpr="station",
													:placeholder="$tCaption('Stations')",
													v-model="stations",
													@select="keys => select('Station', true, keys)",
													@deselect="keys => select('Station', false, keys)")
											DxCheckBox(v-if="!markets.length && !formats.length && !stations.length" :value.sync="item.IsOtherTraffic", :text="$tCaption('All other traffic')", :disabled="readonly")
										.flex-row.actions.justify(v-if="false")
											.left
												.remove.clickable(v-if="item.targets.length > 1 && !readonly", @click="$emit('remove', item, itemIndex)")
													i.fas.fa-trash
											.right
												.clickable(v-if="targetIndex === item.targets.length-1 && !readonly", @click="addTarget(item)")
													i.fas.fa-plus
						.flex-col
							.swing-in-top-fwd.daypart-item.flex-row.align-start.schedule-cell
								.schedule-cell
									.schedule-content.flex-col.space
										.flex-col
											.font-small.upper.grey {{$tCaption('Days')}}
											DxTagBox(:dataSource="dayparts" :value.sync="days", :multiline="true", stylingMode="underlined", tag-template="tagTemplate"
												:showClearButton="false", :showDropDownButton="true", :maxDisplayedTags="7", :showSelectionControls="true", valueExpr="id", displayExpr="text", :disabled="readonly")
												template(v-slot:tagTemplate="{ data }")
													.short-tag(v-if="data && data.text") {{data.text.substr(0,3).toUpperCase()}}
										.flex-row.space
											.flex-col
												.font-small.upper.grey {{$tCaption('Start time')}}
												DxDateBox(:width="95", type="time", :value.sync="item.StartDateTime", pickerType="rollers", :disabled="readonly")
											.flex-col
												.font-small.upper.grey {{$tCaption('End time')}}
												DxDateBox(:width="95", type="time", :value.sync="item.EndDateTime", pickerType="rollers", :disabled="readonly")
										.flex-row.actions.justify(v-if="false")
											.left
												.remove.clickable(v-if="target.dayparts.length > 1 && !readonly", @click="target.dayparts.splice(daypartIndex, 1)")
													i.fas.fa-trash
											.right(v-if="daypartIndex === target.dayparts.length-1 && !readonly", @click="addDaypart(target)")
												.clickable
													i.fas.fa-plus
								.schedule-cell
									.schedule-content.flex-col
										.font-small.upper.grey {{$tCaption('Event rules')}}
										.flex-row.space
											Dropdown(ref="eventRuleDropdown", :getTotal="(d) => d.TotalNumberOfRecords", :getItems="(d) => d.Results", :getData="(a, b, c) => $Data.getRules(a, b, c, true)",
												:columns="[{ dataField: 'Name', caption: $tCaption('Rule') }]", :disabled="readonly"
												displayExpr="Name",
												valueExpr="Oid",
												:placeholder="$tCaption('All event rules')",
												v-model="eventRule",
												:showColumnHeaders="false",
												:filtersVisible="false",
												:searchVisible="true",
												:multiple="false")
											DxButton(icon="more", stylingMode="text", @click="$emit('switch-view', 'rules')", :activeStateEnabled="false", :focusStateEnabled="false", :disabled="readonly")
								.schedule-cell
									.schedule-content
										.content.flex-col.space
											.flex-col.space(v-if="creatives.length")
												template(v-for="(creative, creativeIndex) in creatives")
													.line-creative
														ScheduleEditorInstructionLineCreative(ref="creative", :item="creative", :itemIndex="creativeIndex", :campaignId="campaignId", @remove="v => removeCreative(creative, creativeIndex)", :readonly="readonly")
											.flex-row.actions.justify
												.right(@click="addCreative()", v-if="!readonly")
													.clickable.flex-row.space.align-center
														i.fas.fa-plus
														span {{$tCaption('Add creative')}}
</template>

<script>
	import Data from 'app-core/Data';
	import DxTagBox from 'devextreme-vue/tag-box';
	import DxSelectBox from 'devextreme-vue/select-box';
	import DxTextBox from 'devextreme-vue/text-box';
	import DxDateBox from 'devextreme-vue/date-box';
	import {DxCheckBox} from 'devextreme-vue/check-box';
	import {DxNumberBox} from 'devextreme-vue/number-box';
	import DxButton from 'devextreme-vue/button';
	import DxDropDownBox from 'devextreme-vue/drop-down-box';
	import {DxDataGrid, DxSelection, DxPaging, DxFilterRow, DxScrolling} from 'devextreme-vue/data-grid';
	import Dropdown from 'app-core/Dropdown.vue';
	import FileUploader from 'app-core/FileUploader.vue';
	import EventRules from './ScheduleEventRules.vue';
	import ScheduleEditorInstructionLineCreative from './ScheduleEditorInstructionLineCreative.vue';

	export default {
		translationCategory: 'schedule.ScheduleEditorInstructionLine',
		name: 'schedule-editor-instruction-line',
		components: {
			DxTagBox, DxDateBox, DxCheckBox, DxTextBox, DxSelectBox, DxNumberBox, DxButton, DxDropDownBox,
			DxDataGrid, DxSelection, DxPaging, DxFilterRow, DxScrolling, Dropdown,
			FileUploader, EventRules, ScheduleEditorInstructionLineCreative
		},
		props: ['item', 'itemIndex', 'dataSetRules', 'campaignId', 'readonly'],
		data() {
			const dayparts = [
				{id: 'Monday', text: this.$tCaption('Monday')},
				{id: 'Tuesday', text: this.$tCaption('Tuesday')},
				{id: 'Wednesday', text: this.$tCaption('Wednesday')},
				{id: 'Thursday', text: this.$tCaption('Thursday')},
				{id: 'Friday', text: this.$tCaption('Friday')},
				{id: 'Saturday', text: this.$tCaption('Saturday')},
				{id: 'Sunday', text: this.$tCaption('Sunday')},
			];
			return {
				days: dayparts.filter(f => this.item[f.id] === true).map(f => f.id),
				eventRule: this.item.EventRule && this.item.EventRule.Oid || null,
				stations: this.item.Stations.map(f => f.Name),
				creatives: this.item.InstructionCreatives,
				formats: this.item.Formats.map(f => f.Name),
				markets: this.item.Zones.map(f => f.Name),
				isRemoving: false,
				dayparts
			};
		},
		watch: {
			instruction(v) {
				if (v) {
					this.loadInstructionLines(v);
				}
			},
			days() {
				this.dayparts.map(f => this.item[f.id] = this.days.indexOf(f.id) > -1);
			},
			markets() {
				if (__DEBUG__)
					console.debug('Reload formats');
				this.$refs.formats.reload();
			},
			formats() {
				if (__DEBUG__)
					console.debug('Reload sations');
				this.$refs.stations.reload();
			},
			item: {
				handler() {
					this.saveInstructionLine();
				},
				deep: true
			},
			eventRule(v) {
				if (!this.item.EventRule) this.item.EventRule = {};
				this.item.EventRule.Oid = v;
				this.saveInstructionLine();
			}
		},
		mounted() {
			if (__DEBUG__)
				window.instructionLine = this;
		},
		methods: {
			loadStationsData(pageIndex, limit, opts) {
				return Data.getRadioData(pageIndex, limit, opts, this.markets, this.formats);
			},
			loadMarketsData(pageIndex, limit, opts) {
				return Data.getMarkets(pageIndex, limit, opts);
			},
			loadFormatsData(pageIndex, limit, opts) {
				return Data.getFormats(this.markets, pageIndex, limit, opts);
			},
			removeCreative(creative, creativeIndex) {
				this.item.InstructionCreatives.splice(creativeIndex, 1);
			},
			addCreative() {
				this.item.InstructionCreatives.push({
					InstructionLineId: this.item.Oid,
					CreativeId: null,
					Weight: 1
				});
			},
			saveInstructionLine() {
				const item = {
					...this.item,
					Zones: this.markets.map(f => ({Name: f})),
					Formats: this.formats.map(f => ({Name: f})),
					Stations: this.stations.map(f => ({Name: f}))
				};
				Data.postExternalApi('Instruction/CreateUpdateInstructionLine', item).then(r => {
					if (__DEBUG__)
						console.log('Instruction/CreateUpdateInstructionLine updated', {r});
				});
			},
			select(arrType, isSelected, array) {
				var method = `${isSelected ? 'Add' : 'Remove'}${arrType}s${isSelected ? 'To' : 'From'}InstructionLine`;
				var params = {
					ObjectId: this.item.Oid,
					ItemIds: array
				};
				Data.postExternalApi(`Instruction/${method}`, params).then(r => {
					if (__DEBUG__)
						console.log(`Instruction/${method} results`, {r});
				});
			}
		}
	};
</script>
<style lang='scss'>
	.schedule-editor-instruction-line {
		@import "main/themes/generated/variables.base.scss";

		.actions {
			cursor: pointer;
			&:hover {
				color: $base-accent;
			}
		}

		&.removing {
			opacity: 0.5;
		}

		&.vibrate-1 {
			-webkit-animation: vibrate-1 0.3s linear infinite both;
			animation: vibrate-1 0.3s linear infinite both;
		}

		@-webkit-keyframes vibrate-1 {
			0% {
				-webkit-transform: translate(0);
				transform: translate(0);
			}
			20% {
				-webkit-transform: translate(-2px, 2px);
				transform: translate(-2px, 2px);
			}
			40% {
				-webkit-transform: translate(-2px, -2px);
				transform: translate(-2px, -2px);
			}
			60% {
				-webkit-transform: translate(2px, 2px);
				transform: translate(2px, 2px);
			}
			80% {
				-webkit-transform: translate(2px, -2px);
				transform: translate(2px, -2px);
			}
			100% {
				-webkit-transform: translate(0);
				transform: translate(0);
			}
		}
		@keyframes vibrate-1 {
			0% {
				-webkit-transform: translate(0);
				transform: translate(0);
			}
			20% {
				-webkit-transform: translate(-2px, 2px);
				transform: translate(-2px, 2px);
			}
			40% {
				-webkit-transform: translate(-2px, -2px);
				transform: translate(-2px, -2px);
			}
			60% {
				-webkit-transform: translate(2px, 2px);
				transform: translate(2px, 2px);
			}
			80% {
				-webkit-transform: translate(2px, -2px);
				transform: translate(2px, -2px);
			}
			100% {
				-webkit-transform: translate(0);
				transform: translate(0);
			}
		}
	}
</style>
